import { LabelApi } from '@/epersonam/mixins/labels.js';
import apiConnector from '@/epersonam/apiConnector';

export const EPApiEventMixin = {
  methods: {
    async EP_execute(response) {
      const { event } = response;

      if (event != 'execute') return;

      const { link } = response.data;

      if (link) {
        try {
          response = await apiConnector().get(link);
          eval(response.data);
        } catch (error) {
          console.error('errore', error);
        }
      }
    },
    async EP_printGenerate(response) {
      const { event } = response;

      if (event != 'print_generate') {
        return;
      }

      const { params, worker } = response.data;

      try {
        this.adv_common.openAdvLoader();
        const getParams = new URLSearchParams({ worker, ...params, skip_page_creation: false }).toString();
        let urlGenerateReport = `${window.config.ePersonamService.ePersonamHost}/${window.locale}/reports/generate_report.json?${getParams}`;
        const { data } = await apiConnector().get(urlGenerateReport);
        this.adv_common.closeAdvLoader();
        eventBus.$emit('generateReport', data);
      } catch (error) {
        console.error('errore', error);
      }
    },
    async EP_confirmAlert(response) {
      const { event, data } = response;

      if (event != 'confirm') {
        return;
      }

      const { link, message } = data;

      try {
        if (confirm(message)) {
          await apiConnector().patch(link);
        }
      } catch (error) {
        console.error('errore', error);
      }

      window.location.reload();
    },
  },
};

export const modalMixin = {
  methods: {
    async MDL_openExecute(response) {
      const { event } = response;

      if (event != 'execute') return;

      const { link } = response.data;
      let body = null;

      if (link) {
        try {
          this.adv_common.openAdvLoader();
          body = await this.adv_common.apiConnector('GET').fetch(link, { responseFormat: 'html' });
          eval(body);
          this.adv_common.closeAdvLoader();
        } catch (error) {
          console.error(error);
          this.adv_common.closeAdvLoader();
        }
      }
    },

    MDL_setValueToForm(fields, form_id) {
      if (!fields || !Object.keys(fields).length || !form_id) return;

      for (const key in fields) {
        const value = fields[key];
        if (value) {
          document.querySelector(`#${form_id} [name=${key}]`).value = value;
        }
      }
    },
    async MDL_openBootstrapModal(response) {
      const { event } = response;

      if (event != 'bootstrapModal') return;

      const { link, modal_id, fields, form_id } = response.data;
      let body = null;

      this.MDL_setValueToForm(fields, form_id);

      if (link) {
        try {
          this.adv_common.openAdvLoader();
          body = await this.adv_common.apiConnector('GET').fetch(link, { responseFormat: 'html' });
          this.adv_common.closeAdvLoader();
        } catch (error) {
          console.error(error);
          this.adv_common.closeAdvLoader();
        }
      }
      this.MDL_opendBootstrapModal({ body, modal_id });
    },

    MDL_opendBootstrapModal(options = {}) {
      const { body, modal_id } = options;

      if (!modal_id) return;

      const bootstrapModal = document.querySelector(`#${modal_id}`);
      if (!bootstrapModal) return;

      if (body) {
        bootstrapModal.querySelector('.modal-body').innerHTML = body;
      }

      $(`#${modal_id}`).modal('show');
    },
  },
};

const setupConfigMix = {
  props: {
    baseUrlProp: { type: String, default: null },
  },
  mixins: [LabelApi, modalMixin],
  data() {
    const defaultBaseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
    const baseUrl = this.baseUrlProp || defaultBaseUrl;

    return {
      baseUrl,
      getPropsUrlData: `${baseUrl}/tables/props`,
      setupConfig: {
        neededResources: ['moment'],
        globalData: {
          locale: window.locale,
        },
      },
      listConfig: {
        baseUrl,
      },
    };
  },
};

export { setupConfigMix };
